// Apply corrections before ordering/limiting the operational read model.
export const ACTIVE_CLEANING_EVENTS_FILTER_SQL = `
AND NOT EXISTS (
  SELECT 1 FROM events_local correction, json_each(correction.payload, '$.original_client_uuids') target
  WHERE correction.kind = 'cleaning_voided'
    AND correction.tenant_id = events_local.tenant_id
    AND correction.business_id = events_local.business_id
    AND json_extract(correction.payload, '$.schedule_id') = json_extract(events_local.payload, '$.schedule_id')
    AND target.value = events_local.id
)`;
